/*
 * Note that this is toastr v2.1.3, the "latest" version in url has no more maintenance,
 * please go to https://cdnjs.com/libraries/toastr.js and pick a certain version you want to use,
 * make sure you copy the url from the website since the url may change between versions.
 * */
import * as toastr from "toastr";
toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
}
window.toast = toastr
document.addEventListener( 'livewire:init', () => {

    Livewire.on('toast', (event) => {

        let title = event.title;
        let message = event.message;
        let status = event.status;
        let options = event.options;

        switch (status) {
            case 'error': toast.error(message, title, options); break;
            case 'danger': toast.error(message, title, options); break;
            case 'warning': toast.warning(message, title, options); break;
            case 'success': toast.success(message, title, options); break;
            default: toast.info(message, title, options);
        }
    });

}, { once: true })
